import { render, staticRenderFns } from "./checkout-steps.vue?vue&type=template&id=0872144e&lang=pug&"
import script from "./checkout-steps.vue?vue&type=script&lang=js&"
export * from "./checkout-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports